import { render, staticRenderFns } from "./MMenuLinkItem.vue?vue&type=template&id=279f11bc"
import script from "./MMenuLinkItem.vue?vue&type=script&lang=js"
export * from "./MMenuLinkItem.vue?vue&type=script&lang=js"
import style0 from "./MMenuLinkItem.vue?vue&type=style&index=0&id=279f11bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports